export default {
  computed: {
    dateTimeFormat: function () {
      return 'yyyy-MM-DD HH:mm:ss'
    },
    dateFormat: function () {
      return 'yyyy-MM-DD'
    },
  },
}
